import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';

import {Product} from '../../../models/product.model';
import {Order} from '../../../models/order.model';
import {OrderItem} from '../../../models/order-item.model';
import {OrderItemService} from '../../../services/order-item.service';
import {ProductService} from '../../../services/product.service';
import {AuthService} from '../../../services/auth.service';
import {MobileCheckServiceService} from '../../../services/mobile-check-service.service';
import {SKU} from '../../../models/sku.model';

@Component({
    selector: 'app-product-grid-item',
    templateUrl: './product-grid-item.component.html',
    styleUrls: ['./product-grid-item.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ProductGridItemComponent implements OnInit {

    updatingFavorites = false;

    private _order: Order;

    @Input() product: Product;

    @Input() showFeaturedTag = true;

    @Input() canCreateOrder = false;

    @Input() showOrderSelector = false;

    @Input() set order(val: Order) {
        this._order = val;
    }



    constructor(private authService: AuthService,
                private orderItemService: OrderItemService,
                private productService: ProductService,
                private router: Router,
                private mobileCheck: MobileCheckServiceService) {
    }

    ngOnInit(): void {
    }


    get orderItem(): OrderItem {
        if (!this._order || !this._order.loaded) {
            return null;
        }

        return this._order.findOrderItemByProduct(this.product)
    }


    get orderedQuantity(): number {
        return this.orderItem?.quantity || 0;
    }


    shopProduct() {
        this.orderItemService.shopProduct(this._order, this.product, this.canCreateOrder, this.showOrderSelector);
    }

    get isItemCut(): boolean {
        return this.product?.item_cut ? this.product.item_cut : false;
    }
    get canBuyProduct(): boolean {
        if (this.product.inventoryType) {
            return this.product.inStock;
        }

        return true;
    }

    get canSeeFavorites(): boolean {
        return this.authService.canSeeFavorites;
    }

    get shopLabel(): string {
        if (this.orderItem && this.orderItem.id > 0) {
                return `(${this.orderItem.quantity}) Update`;
        }
        return (this.canBuyProduct) ? 'Quick Shop' : 'Out Of Stock';
    }

    toggleFavorites() {
        this.updatingFavorites = true;
        this.productService.toggleFavorites(this.product).subscribe( retProduct => {
            this.updatingFavorites = false;
            if (retProduct) {
                this.product = retProduct;
            }
        })
    }

    get hasFavorites(): boolean {
        return this.product && this.product.isFavorite;
    }


    get showMinOrder(): boolean {
        if (!this.product.isBuyingWindow) {
            return false;
        }

        if (this.product.hasVariations) {
            return this.product.getGroupMinQuantity() > 0 || this.product.variationsMaxQuantity > 0 || this.product.has_inventory;
        }

        return true;
    }

    get isShopHidden(): boolean {
        if (this.mobile) {
            return true;
        }
        if (this.canCreateOrder && this.authService.canOrder) {
            return false;
        }

        return !this.authService.canEditOrder(this._order) || this._order.limited;
    }

    onImageClicked() {
        this.router.navigate([this.product.productURL]);
    }

    get mobile(): boolean {
        return this.mobileCheck.mobile;
    }

    get imageUrl(): string {
        return this.product.thumbnail;
    }


    get isProductRecommended(): boolean {
        return this.orderItemService.isProductRecommended(this.product, this._order);
    }

    // in case of variations  - get first sku  that contains combined quantity
    get variationSKU(): SKU {
        return this.product.hasVariations ? this.product.firstSku : null
    }
}
